module.exports = __webpack_public_path__ + "static/media/absolin_logo.d765680e.png";